import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { mergeRejectedRuleValidation } from '@cbridge-packages/rule';
import { CoverageRuleAction, coverageRuleStoreSelector } from '@cbridge-packages/coverage-rules';
import { RulesManagementAction, rulesActiveSelector } from '@cbridge-modules/rules-management-page';

type IState =
  & IGetSelectorStateType<typeof rulesActiveSelector>
  & IGetSelectorStateType<typeof coverageRuleStoreSelector>;

// The backend rejected the whole request naming some rules: overlay them on the rows' last
// known state (a 400 carries nothing about the other rules). Editing continues.
export const onCoverageRulesRejectedEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(CoverageRuleAction.validationRejected),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    if (payload.ruleSetId !== coverageRuleStoreSelector(state).ruleSetId) {
      return [];
    }
    return [RulesManagementAction.applyValidation(mergeRejectedRuleValidation(rulesActiveSelector(state), payload.result))];
  }),
);
